<template lang='pug'>
//- 完成註冊區塊
div(:class='$style[`cc-popbox-progress`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-popbox-progress-wrap`]')
    div(:class='$style[`cc-popbox-progress-loading`]')
      ProgressBar(
        :loadAnimate='true'
        :label='0'
        :maxLabel='0')

    div(:class='$style[`cc-popbox-progress-feature`]')
      span.font-medium(v-if='feature === `translate`' :class='$style[`cc-popbox-progress-feature-info`]') 解析中，請稍後
      span.font-medium(v-else-if='feature === `analysis`' :class='$style[`cc-popbox-progress-feature-info`]') 數據分析中，請稍後
      span.font-medium(v-else-if='feature === `recognize`' :class='$style[`cc-popbox-progress-feature-info`]') 影像辨識中，請稍後
      span.font-medium(v-else-if='feature === `prediction`' :class='$style[`cc-popbox-progress-feature-info`]') 健檢預測中，請稍後
      span.font-medium(v-else-if='feature === `login`' :class='$style[`cc-popbox-progress-feature-info`]') 正在驗證登入中...

      span.font-medium(v-if='feature !== `login`' :class='$style[`cc-popbox-progress-feature-tips`]')
        != 'Powered by'
        IconDrCell(:size='13')
        != 'Dr.Cell AI'
      div(v-else :class='$style[`cc-popbox-progress-recaptcha`]')
        span 採用
        figure(:class='$style[`cc-popbox-progress-recaptcha-logo`]')
        span 驗證保護

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import IconLoading from '../../icon/Loading.vue';
import IconDrCell from '../../icon/DrCell.vue';
import ProgressBar from '../common/ProgressBar.vue';

export default {
  components: {
    IconLoading,
    IconDrCell,
    ProgressBar,
  },

  props: {
    // 確認打勾圖樣顏色
    // 訊息文字
    feature: {
      type: String,
      default: '',
    },
  },

  // data() {
  //   return {}
  // },

  methods: {
    ...mapMutations({
      changePopProgressStatus: 'global/POPPROGRESS_STATUS',
    }),

    handleClosePopBox() {
      this.changePopProgressStatus({
        active: false,
        feature: '',
      });
    },

  },

  computed: {
    ...mapGetters({
      // loginDjangoId: 'user/exportUserDjangoId',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      // subscribeVip: 'user/exportUserSubscribeVip',
      // loginHashCode: 'user/exportUserHashCode',
    }),
  },

};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popProgressLoading.scss';
</style>
